import { useEffect } from 'react';

import { useGigyaStore } from '@ciam/gigya-api';
import { useLoadingSpinnerStore } from '@ciam/ui';
import {
  LoginInfoCheck,
  RecordLastLogin,
  useValidatorStore,
  ValidateAllDone,
  ValidateApprovalStatus,
  ValidateConsent,
  ValidatePassword,
  ValidateUserStatus,
} from '@features/proxy';
import { useLoginInfoStore } from '@features/shared';

export const ProxyPage = () => {
  const clearLoginInfo = useLoginInfoStore((state) => state.clearLoginInfo);

  const { showLoading } = useLoadingSpinnerStore();

  const { isGigyaScriptLoaded } = useGigyaStore();
  const { validateStep, setValidateStep } = useValidatorStore();

  useEffect(() => {
    showLoading();
    clearLoginInfo();
  }, [showLoading, clearLoginInfo]);

  // Gigya 세션이 있는 경우 로그인 상태로 변경
  const addOnGigyaServiceReady = useGigyaStore((state) => state.addOnGigyaServiceReady);
  useEffect(() => {
    addOnGigyaServiceReady({
      page: 'proxy',
      hasSessionFn: async () => {
        setValidateStep('login-info-check');
      },
    });
  }, [addOnGigyaServiceReady, setValidateStep]);

  /*
    Gigya Script가 로드되지 않은 경우 null
    아래 순서대로 검증합니다.
    1. login-info-check: 로그인 정보 확인
    2. password-check: 비밀번호 확인
    3. user-status-check: 사용자 상태 확인
    4. approval-status-check: 승인 상태 확인
    5. consent-check: 동의 확인
    6. record-last-login: 마지막 로그인 기록
    7. validate-all-done: 모든 검증 완료
   */
  if (!isGigyaScriptLoaded) return null;
  if (validateStep === 'login-info-check') return <LoginInfoCheck />;
  if (validateStep === 'password-check') return <ValidatePassword />;
  if (validateStep === 'user-status-check') return <ValidateUserStatus />;
  if (validateStep === 'approval-status-check') return <ValidateApprovalStatus />;
  if (validateStep === 'consent-check') return <ValidateConsent />;
  if (validateStep === 'record-last-login') return <RecordLastLogin />;
  if (validateStep === 'validate-all-done') return <ValidateAllDone />;
};
